// Modules
import { createAction, props } from '@ngrx/store';

// Interfaces
import {
  ILoginUser,
  ILoggedUser,
  IGetConfigListadoResponse,
  IConfigListado,
  IMSTokenLogin,
} from '@shared/interfaces';

// --------------- System ----------------
// ---------------------------------------
export const checkForLoggedUser = createAction(
  '[Auth] - Check For Logged User',
  props<{ payload: any }>()
);

// ------------ Login Actions ------------
// ---------------------------------------
export const loginRequested = createAction(
  '[Auth] - Login Requested',
  props<{ payload: ILoginUser }>()
);

export const loginSuccessful = createAction(
  '[Auth] - Login Successful',
  props<{ payload: ILoggedUser }>()
);

export const loginMicrosoftRequested = createAction(
  '[Auth] - Login Microsoft Requested'
);

export const loginMicrosoftSuccess = createAction(
  '[Auth] - Login Microsoft Success'
);

export const loginMicrosoftFailure = createAction(
  '[Auth] - Login Microsoft Failure',
  props<{ payload: any }>()
);

export const loginMSTokenRequested = createAction(
  '[Auth] - Login MSToken Requested',
  props<{ payload: IMSTokenLogin }>()
);

export const loginMSTokenSuccess = createAction(
  '[Auth] - Login MSToken Success',
  props<{ payload: ILoggedUser }>()
);

export const loginMSTokenFailure = createAction(
  '[Auth] - Login MSToken Failure'
);

export const loginFailed = createAction('[Auth] - Login Failed');

export const logoutRequested = createAction(
  '[Auth] - Logout Requested',
  props<{ payload: ILoggedUser }>()
);

export const logoutSuccessful = createAction('[Auth] - Logout Successful');

// ---------------- Token ----------------
// ---------------------------------------
export const updateUserTokens = createAction(
  '[Auth] - Update User Tokens',
  props<{ payload: { accessToken: string; refreshToken: string } }>()
);

// ----------- Password Change -----------
// ---------------------------------------
export const passwordChangeFailed = createAction(
  '[Auth] - Password Change Failed',
  props<{ payload?: { invalidCredentials?: boolean; fieldError?: string } }>()
);

export const passwordChangeRequested = createAction(
  '[Auth] - Password Change Requested',
  props<{
    payload: { email: string; newPassword: string; currentPassword: string };
  }>()
);

export const passwordChangeSuccessful = createAction(
  '[Auth] - Password Change Successful'
);

export const resetPasswordChangeStatuses = createAction(
  '[Auth] - Reset Password Change Statuses'
);

// ----------- Password Reset ------------
// ---------------------------------------
export const passwordResetRequested = createAction(
  '[Auth] - Password Reset Requested',
  props<{ payload: { key: string; newPassword: string } }>()
);

export const passwordResetSuccessful = createAction(
  '[Auth] - Password Reset Successful',
  props<{ payload: any }>()
);

export const verifyPasswordResetRequested = createAction(
  '[Auth] - Verify Password Reset Requested',
  props<{ payload: { key: string } }>()
);

export const verifyPasswordResetResponse = createAction(
  '[Auth] - Verify Password Reset Response',
  props<{ payload: { invalid: boolean } }>()
);

export const passwordResetFailed = createAction(
  '[Auth] - Password Reset Failed',
  props<{ payload?: { fieldError?: string } }>()
);

export const passwordRecoveryRequested = createAction(
  '[Auth] - Password Recovery Requested',
  props<{ payload: { email: string } }>()
);

export const passwordRecoveryResponse = createAction(
  '[Auth] - Password Recovery Response'
);

export const activationRequested = createAction(
  '[Auth] - Activation Requested',
  props<{ payload: { key: string; password: string } }>()
);

export const activationSuccessful = createAction(
  '[Auth] - Activation Successful',
  props<{ payload: any }>()
);

export const verifyActivationRequested = createAction(
  '[Auth] - Verify Activation Requested',
  props<{ payload: { key: string } }>()
);

export const verifyActivationResponse = createAction(
  '[Auth] - Verify Activation Response',
  props<{ payload: { invalid: boolean } }>()
);

export const activationFailed = createAction(
  '[Auth] - Activation Failed',
  props<{ payload?: { fieldError?: string } }>()
);

export const getConfigListadoRequested = createAction(
  '[Auth] - Get Config Listado Requested',
  props<{ payload: { key: string } }>()
);

export const getConfigListadoResponse = createAction(
  '[Auth] - Get Config Listado Response',
  props<{ payload: IGetConfigListadoResponse }>()
);

export const setConfigListadoRequested = createAction(
  '[Auth] - Set Config Listado Requested',
  props<{ payload: IConfigListado }>()
);

export const setConfigListadoResponse = createAction(
  '[Auth] - Set Config Listado Response',
  props<{ payload: any }>()
);
